import React, { forwardRef } from 'react';
import clsx from 'clsx';
import { Badge, IconButton } from '@walmart-web/livingdesign-components';
import { Bell as BellIcon } from '@livingdesign/icons';

import styles from './styles.module.css';
import { useAppSelector } from '../../../redux/hooks.ts';
import { notificationsSelectors } from '../../../redux/slices/notifications.ts';

type Props = {
  onClick: () => void;
};

const NotificationButton = forwardRef<HTMLButtonElement, Props>(
  ({ onClick }, ref) => {
    const unreadCount = useAppSelector(notificationsSelectors.selectCount);

    return (
      <IconButton
        ref={ref}
        size="medium"
        a11yLabel="notifications button"
        onClick={onClick}
        UNSAFE_className={styles.notificationsButton}
      >
        <BellIcon
          size="medium"
          className={clsx(unreadCount === 0 && styles.lightColor)}
        />
        {unreadCount > 0 && (
          <Badge UNSAFE_className={styles.notificationsUnreadCountBadge}>
            {unreadCount > 99 ? '99+' : unreadCount}
          </Badge>
        )}
      </IconButton>
    );
  }
);

export default NotificationButton;
